module.exports = __webpack_public_path__ + "img/spin2.6b1d461f.png";